import styled from 'styled-components'

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`

export const DesktopWrapper = styled.div`
  display: block;

  @media (max-width: 767px) {
    display: none;
  }
`

export const WaveContainer = styled.div<{
  type: 'squareImageHeader' | 'fullImageHeader' | 'defaultHeader'
  largeCurve?: boolean
}>`
  background: var(--brand-primary);
  width: 100%;
  height: ${({ type }) => (type === 'fullImageHeader' ? '665px' : '600px')};
  z-index: 0;
  position: absolute;
  ${({ type }) => (type === 'defaultHeader' ? 'bottom: 0' : 'top: 0')};
  left: 0;

  ${({ largeCurve }) =>
    largeCurve &&
    `
    @media (max-width: 1100px) {
      height: 600px;
      overflow: hidden;
      
      > div {
        height: 35%;
        width: 150%;
        left: -20%;
      }
    }
  `}

  @media (max-width: 767px) {
    min-height: auto;
    overflow: hidden;

    ${({ largeCurve }) =>
      largeCurve
        ? `
          height: 72vh;
        `
        : `
          height: 145%;
          width: 100vw;
          left: -25px;
          top: -40px;
        `}

    > div {
      height: 40%;
      width: 150%;
      left: -20%;
    }
  }
`

export const StaticWaveContainer = styled.div`
  width: 100%;
  height: 100px;
  position: relative;
  overflow: hidden;

  @media (max-width: 767px) {
    > div {
      width: 135%;
      left: -15%;
    }
  }
`

export const Description = styled.p`
  font-size: 16px;
  font-weight: var(--font-regular);
  line-height: 1.6;
`

export const FullImageWrapper = styled.div<{ image: string }>`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 455px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;

  &::before {
    border-radius: 20px;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-image: url('${({ image }) => image}');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 0;
  }

  ${Description} {
    color: white;
    font-weight: var(--font-medium);
  }

  @media (max-width: 600px) {
    height: 250px;

    & > h1 {
      font-size: 24px;
    }

    & > h2 {
      font-size: 14px;
    }
  }
`

export const FullImageContentWrapper = styled.div`
  background-color: black;
  padding: 40px;
  border-radius: 15px;
  position: absolute;
  bottom: 40px;
  left: 40px;
  z-index: 1;
  width: 400px;

  & > h1 {
    z-index: 1;
    color: white;
    position: relative;
  }

  & > h2 {
    color: white;
    z-index: 1;
    font-weight: var(--font-regular);
    font-size: 16px;
  }

  @media (max-width: 600px) {
    background-color: black;
    & > h1 {
      font-size: 24px;
    }

    & > h2 {
      font-size: 14px;
    }
  }
`

export const SquareImageContentWrapper = styled.div`
  max-width: 400px;

  & > h2 {
    font-weight: var(--font-regular);
    font-size: 16px;
  }

  @media (max-width: 600px) {
    & > h1 {
      font-size: 24px;
    }

    & > h2 {
      font-size: 14px;
    }
  }
`

export const SquareImageWrapper = styled.div<{ noImage: boolean }>`
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px;
  position: relative;

  & > img {
    border-radius: 20px;
    object-fit: cover;
    width: 420px;
    height: 420px;
  }

  ${({ noImage }) =>
    noImage &&
    `
    ${SquareImageContentWrapper} {
      max-width: unset;
      width: 100%;
    }
  `}

  @media (max-width: 1200px) {
    justify-content: space-between;

    & > img {
      width: 40%;
    }
  }
`

export const HeaderWrap = styled.div`
  position: relative;
`
export const DefaultHeaderCont = styled.div`
  background: var(--brand-primary);
  position: relative;

  @media (max-width: 767px) {
    margin-bottom: -30px;
  }
`
export const DefaultWrapper = styled.div`
  width: 100%;
  margin-top: 50px;
  margin-bottom: 10px;
  position: relative;

  & > h2 {
    font-weight: var(--font-regular);
    font-size: 16px;
    line-height: 22px;
  }

  @media (max-width: 767px) {
    margin-top: 20px;
    margin-left: 0;
    margin-bottom: 0;

    & > h1 {
      font-size: 32px;
    }

    & > h2 {
      font-size: 16px;
    }
  }
`
